import {Button} from "aria";
import formatters from "helpers/formatters.jsx";
import {useState} from "react";
import {DownloadIcon} from "./icons.jsx";
import * as XLSX from "xlsx/xlsx.mjs";

const DownloadBtn = ({totalRows, columns, fileName, refreshData}) => {
  const [busy, setBusy] = useState(false)
  const exportData = async () => {
    if (totalRows > 10000000) return alert(`No es posible exportar mas de 1.000.000 registros. total mostrados: ${formatters.number(totalRows)}`)
    setBusy(true)
    try {
      const {data} = await refreshData(true)
      const parsedColumns = columns.filter(column => column.exportFormat)
      for (const row of data) {
        for (const column of parsedColumns) {
          row[column.accessorKey] = column.exportFormat(row)
        }
      }
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data, {dense: true});
      XLSX.utils.book_append_sheet(workbook, worksheet);
      XLSX.writeFile(workbook, fileName ? `${fileName}.xlsx` : "data.xlsx");
    } catch (err) {
      alert(`ocurrió un error exportando los datos: ${err.message}`)
    }
    setBusy(false)
  }
  return (
    <Button onClick={exportData} isDisabled={busy}>{busy ? 'Espere...' : 'Exportar'} </Button>
  );
};

export default DownloadBtn;